export const constant = {
	selector: {
		target: '.feedback-messenger-window',
		subjectInputTarget: '.feedback-messenger-window input[name="subject"]',
		requiredSubjectPart: 'data-clm-required-subject-part',
	},
}
